import * as React from "react";

function SvgIcons8People(props, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <path d="M16 8c-2.75 0-5 2.25-5 5 0 1.516.707 2.863 1.781 3.781a7.186 7.186 0 00-2.656 2.407 5.232 5.232 0 00-1.344-1.344C9.523 17.117 10 16.114 10 15c0-2.2-1.8-4-4-4s-4 1.8-4 4c0 1.113.477 2.117 1.219 2.844A5.041 5.041 0 001 22h2a3 3 0 016 0v1h2c0-2.754 2.246-5 5-5s5 2.246 5 5h2v-1a3 3 0 016 0h2a5.041 5.041 0 00-2.219-4.156C29.523 17.117 30 16.114 30 15c0-2.2-1.8-4-4-4s-4 1.8-4 4c0 1.113.477 2.117 1.219 2.844-.52.351-.989.828-1.344 1.343a7.186 7.186 0 00-2.656-2.406C20.293 15.863 21 14.516 21 13c0-2.75-2.25-5-5-5zm0 2c1.668 0 3 1.332 3 3s-1.332 3-3 3-3-1.332-3-3 1.332-3 3-3zM6 13c1.117 0 2 .883 2 2s-.883 2-2 2-2-.883-2-2 .883-2 2-2zm20 0c1.117 0 2 .883 2 2s-.883 2-2 2-2-.883-2-2 .883-2 2-2z" />
    </svg>
  );
}

export default React.forwardRef(SvgIcons8People);
